define(['jquery', 'bing', 'c21/maps', 'c21/ajax', 'c21'], function ($, BingMaps, C21Maps, ajax, c21) {
   "use strict";

   var self = {},
      iTestimonialTimer = null,
      mMap = null,
      sUrlPrepend = '';

   var agentTestimonialCarousel = jQuery('#agentTestimonialsCarousel');
   var agentCarousel = jQuery('#carousel-our-agents');

   // Agent carousel
   window.toggleHomePageCarousel = function(carouselName) {
      var carousel;
      if (carouselName === 'agents') {
         carousel = agentCarousel;
      } else if (carouselName === 'testimonials') {
         carousel = agentTestimonialCarousel;
      }

      var playPause = carousel.find('.play-pause-controls');
      var mode = playPause.data('mode');
      if (mode === 'pause') {
         playPause.data('mode', 'play');
         playPause.removeClass('carousel-paused').addClass('carousel-playing');
         playPause.find('.carousel-play-pause').removeClass('carousel-pause').addClass('carousel-play');
         playPause.find('.button-mode').text('Play');
      } else if (mode === 'play') {
         playPause.data('mode', 'pause');
         playPause.removeClass('carousel-playing').addClass('carousel-paused');
         playPause.find('.carousel-play-pause').removeClass('carousel-play').addClass('carousel-pause');
         playPause.find('.button-mode').text('Pause');
      }

      if (carouselName === 'agents') {
         if (mode === 'pause') {
            agentCarousel.carousel('pause');
         } else {
            agentCarousel.carousel('cycle');
         }
      } else if (carouselName === 'testimonials') {
         if (mode === 'pause') {
            agentTestimonialCarousel.carousel('pause');
         } else {
            agentTestimonialCarousel.carousel('cycle');
         }
      }
   };

   window.goToPreviousAgentSlide = function() {
      agentCarousel.carousel('prev');
      agentCarousel.carousel('pause');
      setPauseStyles(agentCarousel);
   };

   window.goToNextAgentSlide = function() {
      agentCarousel.carousel('next');
      agentCarousel.carousel('pause');
      setPauseStyles(agentCarousel);
   };

   // Testimonial carousel
   window.playTestimonialCarousel = function() {
      agentTestimonialCarousel.carousel('cycle');
   };

   window.pauseTestimonialCarousel = function() {
      agentTestimonialCarousel.carousel('pause');
   };

   window.goToPreviousTestimonialSlide = function() {
      agentTestimonialCarousel.carousel('prev');
      agentTestimonialCarousel.carousel('pause');
      setPauseStyles(agentTestimonialCarousel);
   };

   window.goToNextTestimonialSlide = function() {
      agentTestimonialCarousel.carousel('next');
      agentTestimonialCarousel.carousel('pause');
      setPauseStyles(agentTestimonialCarousel);
   };

   function setPauseStyles(carousel) {
      var playPause = carousel.find('.play-pause-controls');
      playPause.removeClass('carousel-paused').addClass('carousel-playing');
      playPause.find('.carousel-play-pause').removeClass('carousel-pause').addClass('carousel-play');
      playPause.find('.button-mode').text('Play');
      playPause.data('mode', 'play');
   }

   function initializeAgentCarousel() {
      var items = $('#carousel-our-agents.carousel .item');
      var slideCount = items.length;

      if (slideCount > 5) {
         items.each(function(){
            var minPerSlide = 3;
            var next = $(this).next();
            if (!next.length) {
               next = $(this).siblings(':first');
            }
            next.children(':first-child').clone().appendTo($(this));

            for (var i = 0; i < minPerSlide; i++) {
               next = next.next();
               if (!next.length) {
                  next = $(this).siblings(':first');
               }

               next.children(':first-child').clone().appendTo($(this));
            }
         });

         $(window).load(function() {
            agentCarousel.carousel('pause');
         });
      } else {
         $('#carousel-our-agents').removeAttr('data-ride');
      }
   }

   function initializeMap() {
      var jHolder = $('#serviceAreaHomeMap'),
          location;

      if (mMap !== null && !jHolder.hasClass('hasMap')) {
         mMap = null;
      }
      if (mMap === null && jHolder.is(":visible")) {
         jHolder.addClass('hasMap');
         location = new BingMaps.Location(jHolder.data("lat"), jHolder.data("lon"));

         mMap = new BingMaps.Map(jHolder.get(0), {
            credentials: C21Maps.bingmapCredentials,
            center: location,
            showDashboard: false,
            zoom: 13,
            mapTypeId: BingMaps.MapTypeId.auto,
            customizeOverlays: true,
            enableSearchLogo: false,
            disableUserInput: true
         });
         mMap.entities.push(new BingMaps.Pushpin(location, {
            icon: "/images/eco/icons/pushpins/main_office.png",
            width: 47,
            height: 54
         }));
      }
   }

   function initializeSearchBoxes(sWhich) {
      var jLocation = $("#location-"+sWhich),
          jButton = $("#button-"+sWhich),
          jBaths = $("#bath-group-"+sWhich),
          jBathInput = $("#baths-"+sWhich),
          jBathCount = $("#bath-count-"+sWhich),
          jBeds = $("#bed-group-"+sWhich),
          jBedInput = $("#beds-"+sWhich),
          jBedCount = $("#bed-count-"+sWhich),
          sLast = null;

      jBaths.find("a").each(function() {
         var jBath = $(this);

         jBath.click(function() {
            jBathCount.text('(' + jBath.text() + ')');
            jBathInput.val(jBath.data('value'));
         });
      });

      jBeds.find("a").each(function() {
         var jBed = $(this);

         jBed.click(function() {
            jBedCount.text('(' + jBed.text() + ')');
            jBedInput.val(jBed.data('value'));
         });
      });

      jLocation.on('change keyup', function(e) {
         var sVal = jLocation.val();

         if (e.which === 13) {
            submitSearchBox(sWhich, e);
            return;
         }
         if (sVal !== null && sVal.length >= 3 && sVal !== sLast) {
            sLast = sVal;
            $.get(sUrlPrepend+"/eco/findahome/autocomplete", {
               location: sVal
            }, function (data) {
               if (data.search.freetextsearch === 'SINGLE_RESULT' ||
                  data.search.freetextsearch === 'SINGLE_LOCATION' ||
                  data.search.freetextsearch === 'EXACT_LOCATION_MATCH') {
                  showAutosuggestOptions(sWhich, []);
               } else {
                  showAutosuggestOptions(sWhich, data.search.alllocations);
               }
            });
         } else if (sVal.length < 3) {
            hideAutosuggestOptions(sWhich);
         }
      }).on('keydown', function(e) {
         if (e.which === 13) {
            submitSearchBox(sWhich, e);
            return;
         }
      }).on('blur', function(e) {
         hideAutosuggestOptions(sWhich);
      });

      jButton.click(function(e) {
         submitSearchBox(sWhich, e);
      });
   }

   function submitSearchBox(sWhich, e) {
      var sLocation = $("#location-"+sWhich).val(),
          jFeatured = $("#featured-"+sWhich),
          jBathInput = $("#baths-"+sWhich),
          jBedInput = $("#beds-"+sWhich),
          jError = $("#error-message-"+sWhich);

      jError.html('');

      e.preventDefault();

      if (sLocation) {
         $.get(sUrlPrepend + "/eco/findahome/search", {
            location: sLocation,
            baths: jBathInput.val(),
            beds: jBedInput.val()
         }, function (data) {
            if (data.search.freetextsearch === 'SINGLE_RESULT' ||
               data.search.freetextsearch === 'SINGLE_LOCATION' ||
               data.search.freetextsearch === 'EXACT_LOCATION_MATCH') {
               var url = data.redirectUrl;

               if (jFeatured.is(":checked")) {
                  var aUrl = url.split('?'),
                      oFeatured = c21.queryToJSON(jFeatured.data("featured-query").split('?')[1]),
                      oRedirect = ((aUrl.length > 1) ? c21.queryToJSON(aUrl[1]) : {});

                  delete oFeatured.lid;

                  url = aUrl[0] + "?" + $.param($.extend(oFeatured, oRedirect));
               }
               ajax.gotoPageUrl(url);
            } else {
               jError.html('Please enter a city, state, or zip code, or select "Search only featured listings".');
               showAutosuggestOptions(sWhich, data.search.alllocations);
            }
         });
      } else if (jFeatured.is(":checked")) {
         var aUrl = jFeatured.data("featured-query").split('?'),
             oOverrides = {};

         if (jBathInput.val()) {
            oOverrides.ba = jBathInput.val();
         }

         if (jBedInput.val()) {
            oOverrides.be = jBedInput.val();
         }

         if (aUrl.length < 2 || !aUrl[1]) {
            aUrl[1] = '';
         }

         ajax.gotoPageUrl(aUrl[0] + "?" + $.param($.extend(c21.queryToJSON(aUrl[1]), oOverrides)));
      } else {
         jError.html('Please enter a city, state, or zip code, or select "Search only featured listings".');
         return false;
      }
   }

   function showAutosuggestOptions(sWhich, aSuggestions) {
      var jOptions = $("#autosuggest-"+sWhich),
//          jGroup = jOptions.parent(),
          jLocation = $("#location-"+sWhich);
      jOptions.html('');
//      jGroup.removeClass('open');
      $.each(aSuggestions, function (i, oSuggestion) {
         var jOption = $('<li><a href="javascript:void(0);">'+oSuggestion.location.displayName+'</a></li>');
         jOption.click(function() {
            jLocation.val(jOption.text());
//            jGroup.dropdown('toggle');
//            jGroup.removeClass('open');
         });
         jOptions.append(jOption);
      });
      if (jOptions.children().length) {
//         jGroup.dropdown('toggle');
//         jGroup.addClass('open');
      }
   }

   function hideAutosuggestOptions(sWhich) {
      var jOptions = $("#autosuggest-"+sWhich);

      setTimeout(function() {jOptions.html('');}, 100);

//      var jGroup = $("#autosuggest-"+sWhich).parent();
//      jGroup.removeClass('open');
   }

   function initializeViewMore() {
      $('.serviceAreasList').on('click', 'a.viewMore', function (e) {
         e.preventDefault();
         $('.serviceArea.hide').addClass('show').removeClass('hide');
         $(this).hide();
         $(this).siblings('a.viewLess').show();
      });

      $('.serviceAreasList').on('click', 'a.viewLess', function (e) {
         e.preventDefault();
         $('.serviceArea.show').addClass('hide').removeClass('show');
         $(this).hide();
         $(this).siblings('a.viewMore').show();
      });
   }


   self.initialize = function() {
      $(window).on('resize', initializeMap);
      initializeMap();
      initializeViewMore();
      initializeSearchBoxes('latest');
      initializeSearchBoxes('featured');
      pauseTestimonialCarousel();
      initializeAgentCarousel();
   };

   return self;
});